module.exports = __webpack_public_path__ + "media/images/mypage/btn06_ov-1ab163fffa2eef8064ec7d80541eaa28.gif";